module.exports = __webpack_public_path__ + "media/images/form-status-in-progress-ecdb6da3.gif";